import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

interface IShareModalProps {
  open: boolean;
  onClose: () => void;
  header: React.ReactNode;
  content: React.ReactNode;
}

export const ShareSettingsModal: React.FunctionComponent<IShareModalProps> = ({ open, onClose, content, header }) => {
  return <ModalWindow open={open} onClose={onClose} width={584} header={header} content={content} />;
};
